export const LOCALSEO_FILTER = [
  {id: 1, name: 'filter_with_data', header: 'Business', filterField: 'business', text: '', type: undefined, active: false, isSearch: false},
  {id: 2, name: 'exclude', header: 'Keyword', filterField: 'keyword', text: '', type: undefined, active: false, isSearch: false},
  {id: 3, name: 'avg_score', header: 'Avg score', from: undefined, to: undefined, type: undefined, active: false, isDecimals: true},
];
